"use client";

import AdminSidebar from "../../../components/AdminSidebar";
import { useState } from "react";
import { useRouter } from "next/navigation";

export default function NuevaRuta() {
  const router = useRouter();
  const [form, setForm] = useState({ origen:"", destino:"", horario:"", precio:"", empresa:"" });
  const [msg, setMsg] = useState("");

  async function guardar(e: React.FormEvent) {
    e.preventDefault();
    setMsg("Guardando...");

    try {
      const res = await fetch("/api/rutas", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form)
      });

      const data = await res.json();

      if (!res.ok) {
        setMsg("Error: " + JSON.stringify(data));
        return;
      }

      setMsg("Ruta guardada correctamente");
      setTimeout(() => router.push("/admin/rutas"), 500);
    } catch (err:any) {
      setMsg("Error JS: " + err.message);
    }
  }

  return (
    <main style={{minHeight:"100vh",background:"#050b18",color:"#fff",fontFamily:"sans-serif"}}>
      <AdminSidebar />
      <section style={{marginLeft:"260px",padding:"40px"}}>
        <h1 style={{color:"#f5a623",fontSize:"32px"}}>Nueva Ruta</h1>

        <form onSubmit={guardar} style={card}>
          <label>Origen</label>
          <input required style={input} value={form.origen} onChange={e=>setForm({...form,origen:e.target.value})} />

          <label>Destino</label>
          <input required style={input} value={form.destino} onChange={e=>setForm({...form,destino:e.target.value})} />

          <label>Horario</label>
          <input required type="time" style={input} value={form.horario} onChange={e=>setForm({...form,horario:e.target.value})} />

          <label>Precio</label>
          <input required style={input} value={form.precio} onChange={e=>setForm({...form,precio:e.target.value})} />

          <label>Empresa</label>
          <input required style={input} value={form.empresa} onChange={e=>setForm({...form,empresa:e.target.value})} />

          <button type="submit" style={button}>Guardar Ruta</button>

          {msg && <p style={{marginTop:"18px",color:"#f5a623"}}>{msg}</p>}
        </form>
      </section>
    </main>
  );
}

const card={maxWidth:"800px",background:"#0f1d36",padding:"30px",borderRadius:"18px",marginTop:"25px"};
const input={width:"100%",padding:"12px",margin:"8px 0 20px",borderRadius:"10px",border:"1px solid #24324d",background:"#07111f",color:"#fff"};
const button={background:"#f5a623",color:"#000",border:"none",padding:"14px 22px",borderRadius:"10px",fontWeight:"bold",cursor:"pointer"};
